/**
 * Listener Implementation to ensure `newPassword` and
 * `confirmPassword` are the same before send.
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
export default class ChangePasswordFormListener {
  /**
   * Our value we want to campare.
   */
  private password: string;
  private confirmPassword: string;

  /**
   * Hook method that only store `newPassword` state
   * which will be used by `onConfirmPasswordStateChange` method
   * that make the comparation.
   */
  onPasswordStateChange({ value, manager }) {
    const { confirmPassword } = manager.getData();
    if (value === confirmPassword) manager.setControlAsValid('confirmPassword', value);
    else if (confirmPassword !== undefined && value !== confirmPassword) manager.setControlAsInvalid('confirmPassword', 'PasswordShouldBeTheSame', value);
    this.password = value;
  }

  /**
   * Hook method that compare if two password `newPassword` and `confirmPassword`
   * are equals, if not set `confirmPassword` controller as invalid, which in UI
   * will be rendered a error message.
   */
  onConfirmPasswordStateChange({ value, manager }) {
    if (value !== this.password) manager.setControlAsInvalid('confirmPassword', 'PasswordShouldBeTheSame', value);
    else manager.setControlAsValid('confirmPassword', value);
  }
}
